import axios from '../../axios'

//查询
export const getOrderInfo = data => {
    return axios({
        url: '/api/data/wish/abroad/item/direction',
        method: 'get',
        data: data.data
    })
}

//增加或编辑
export const AddOrEditOrder = data => {
    return axios({
        url: '/api/data/wish/abroad/item/direction',
        method: data.method || 'GET',
        data: data.data
    })
}

//删除
export const delOneOrderInfo = data => {
    return axios({
        url: '/api/data/wish/abroad/item/direction',
        method: 'DELETE',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/adroad/direction.js